export enum TableFilter {
  DEFAULT = 'default',
  TICKETS = 'tickets',
  SCORES = 'scores',
}
